import { DatePipe, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GradeModel } from 'src/app/Models/GradeModel';
import { Registration } from 'src/app/Models/RegistrationModel';
import { CacheService } from 'src/app/services/cache.service';
import { CourceService } from 'src/app/services/cource.service';
import { NotificationService } from 'src/app/services/notification.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserService } from 'src/app/services/user.service';
import { StorageKey, StorageType } from 'src/app/storage-key';
import { NotificationType } from 'src/app/enum/NotificationType';
import { NumberValidator } from 'src/app/country-picker/number-validator';
import { TrialService } from 'src/app/services/trial.service';
import { TrialUserComponent } from '../trial-user/trial-user.component';
import { ClientIPAddressService } from 'src/app/services/client-ipaddress.service';
import { CMSNavigationService } from 'src/app/services/cms-navigation.service';
import { OtpVerificationComponent } from '../otp-verification/otp-verification.component';
import { SourceIdEnum } from 'src/app/Models/sourceIdEnumModel';
import { CountryCodeModel } from 'src/app/Models/CountryCode.Model';
import { LeadFormTitle, LeadFormType } from 'src/app/enum/LeadFormTitle';
import { ConnectToCounsellorComponent } from '../connect-to-counsellor/connect-to-counsellor.component';
import { AuthService } from 'src/app/services/auth.service';
import { of } from 'rxjs';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
})
export class RegistrationComponent implements OnInit {
  @Output() isUserLogged: EventEmitter<any> = new EventEmitter();
  @Output() userid: EventEmitter<any> = new EventEmitter();
  @Output() isRegistered: EventEmitter<any> = new EventEmitter();

  @Input() sourceId: number = 1;
  @Input() pageTitle: string = '';
  @Input() pageType: number = 1; // 1: Banner, 2: Forum, 3: Registration, 4: CMS

  form!: FormGroup;
  isLoading: boolean = false;
  getGrade: Array<GradeModel> = [];
  userDetails: any;
  registration!: Registration;
  userID!: number;
  phoneNumber: string = '';
  @Input() isShowCrossbtn: boolean = false;
  @Input() password!: string;
  @Input() isGoogleSignIn!: boolean;
  @Input() googleSignInUserId!: string;
  @Input() isEmailDisabled!:boolean;;
  UserId: number | undefined;
  clientIPAdress!: string;
  country!: string;
  city!: string;
  state!: string;
  otp: string | undefined;
  verificationId: number | undefined;
  countryCodes: any[] = CountryCodeModel;
  email:string='';

  constructor(
    private courceService: CourceService,
    private modalService: NgbModal,
    private storageService: StorageService,
    private cacheService: CacheService,
    private authService: AuthService,
    private userService: UserService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private trialService: TrialService,
    private clientIPAdressService: ClientIPAddressService,
    private cmsService: CMSNavigationService,
    public activeModal: NgbActiveModal,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private dom: any
  ) {
    this.form = this.formBuilder.group({
      phoneNumber: ['', [Validators.required, NumberValidator]],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')]],
      gradeId: ['', Validators.required],
    });
  }

  ngOnInit() {
    const backdrop = this.dom.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.classList.remove('modal-backdrop', 'fade', 'show');
    }
    this.courceService.getAllGrades().subscribe((res) => {
      this.getGrade = res;
    });
    
    this.form.patchValue({
      email: this.storageService.getItem(StorageKey.EMAIL, StorageType.LOCAL),
    });
    
    // Disable email field if isEmailDisabled is true (after patching value)
    if (this.isEmailDisabled==true) {
      this.email = this.form.value.email;
      this.form.get('email')?.disable();
    }
    
    this.phoneNumber = this.storageService.getItem(StorageKey.MOBILE_NO, StorageType.LOCAL);
    if (this.phoneNumber == null) {
      this.form.patchValue({
        phoneNumber: '',
      });
    } else {
      this.form.patchValue({
        phoneNumber: this.phoneNumber,
      });
    }
    this.clientIPAdressService.getClientIp().subscribe((data: any) => {
      this.clientIPAdress = data.response.query;
      //this.country = data.response.country;
      this.state = data.response.state;
    });
  }
  get f() {
    return this.form?.controls;
  }
  validateUser() {
    if (this.isGoogleSignIn == true) {
      this.sourceId == SourceIdEnum.GoogleSignIn;
    }
    if (!this.form.invalid) {
      this.isLoading = true;
      // if (this.phoneNumber == null) {
        this.phoneNumber = this.form.value.phoneNumber;
        if(!this.isEmailDisabled==true){
        this.email = this.form.value.email;
        }
      // } else {
      //   this.isLoading = false;
      //   this.phoneNumber = this.phoneNumber;
      // }
      this.userService.checkUser(this.phoneNumber, this.email).subscribe({
        next: (isExistUser) => {
          if (isExistUser.email ===  this.email && isExistUser.mobile === this.phoneNumber) {
            this.userID = isExistUser.id;
            this.sourceId = isExistUser.sourcenameid;
            this.isLoading = true;
            this.password = isExistUser.password;
            this.sourceId = SourceIdEnum.Forum;
            if (this.pageType != LeadFormType.Forum) {
              this.updateUserDetails();
              this.getUserDetailsById(this.userID);
              this.isRegistered.emit(false);
              this.isUserLogged.emit(true);
              this.closeModal();
              this.notificationService.notifyMessage(NotificationType.Success, `You're successfully logged in!`);
              this.getUserStatus();
              this.cmsService.hideNRIBookNowButton();
            } else {
              this.modalService.open(ConnectToCounsellorComponent, { centered: true, backdrop: 'static' });
            }
          } else {
            if (isExistUser.mobile === this.phoneNumber) {
              this.isLoading = false;
            this.notificationService.notifyMessage(
              NotificationType.Warning,
              `You're already Register with this number!`
            );
            }
            else if (isExistUser.email ===  this.email) {
              this.isLoading = false;
            this.notificationService.notifyMessage(
              NotificationType.Warning,
              `You're already Register with this Email!`
            );
            }
            else {
              this.registerUser();
            }
            
          }
        },
        error: () => {
          if (this.isGoogleSignIn == true) {
            this.sourceId = SourceIdEnum.GoogleSignIn;
            // this.userID = Number(this.googleSignInUserId);
            if (this.pageType != LeadFormType.Forum) {
            this.registerUser();
              // this.updateUserDetails();
            } else {
              this.modalService.open(ConnectToCounsellorComponent, { centered: true, backdrop: 'static' });
            }
          } else {
            this.isLoading = false;
            this.registerUser();
          }
        },
      });
    } else {
      this.form.markAllAsTouched();
      return;
    }
  }

  transformDate(date: string | number | Date) {
    return this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ss.SSS'Z'");
  }

  registerUser() {
    this.isLoading = true;
    const countrydata = this.countryCodes.find((x) => x.code == this.form.value.phoneNumber.split('-')[0]);
    this.country = countrydata.country;
    this.activeModal.close();
    // const modalRefOTPVerification = this.modalService.open(OtpVerificationComponent, {
    //   centered: true,
    //   backdrop: 'static',
    // });
    // modalRefOTPVerification.componentInstance.phoneNo = this.form.value.phoneNumber;
    // modalRefOTPVerification.componentInstance.isOtpVerfied.subscribe((isOtpVerfied: any) => {
    //   modalRefOTPVerification.componentInstance.otp.subscribe((otp: string) => {
    //     this.otp = otp;
    //     modalRefOTPVerification.componentInstance.VerificationId.subscribe((VerificationId: number) => {
          //this.verificationId = VerificationId;
          //if (isOtpVerfied == true) {
            this.registration = {
              id: 0,
              name: this.form.value.name,
              email: this.email,
              isActive: true,
              password: this.password,
              mobile: this.form.value.phoneNumber,
              createdDateTime: this.transformDate(new Date())?.toString(),
              modifiedBy: '',
              userTypeId: 1,
              lastModified: this.transformDate(new Date())?.toString(),
              registrationUrl: String(window.location.pathname),
              sourceNameId: this.sourceId,
              ipCountry: this.country,
              ipAddress: this.clientIPAdress,
              city: '',
              VerificationId: this.verificationId,
             // otp: this.otp,
              userDetails: {
                id: 0,
                grade: String(this.form.value.gradeId),
                userId: 0,
                schoolName: '',
                modifiedDate: this.transformDate(new Date())?.toString(),
              },
              // mobileVerification: {
              //   verificationId: 0,
              // },
            };
            if (this.registration.mobile != null) {
              this.userService.create(this.registration).subscribe((data) => {
                const userId = this.persistAuthResponse(data) ?? Number(data?.userId ?? data?.result?.value?.id ?? 0);
                if (userId) {
                  this.userID = userId;
                  if (this.pageType != LeadFormType.Forum) {
                    this.authenticateAndFinalize(
                      this.email,
                      this.password,
                      this.userID,
                      false,
                      `You're Register Successfully!`
                    );
                  } else {
                    this.modalService.open(ConnectToCounsellorComponent, { centered: true, backdrop: 'static' });
                    this.isLoading = false;
                  }
                } else {
                  this.isLoading = false;
                  this.notificationService.notifyMessage(NotificationType.Warning, `Sorry ! Unable to Register you!`);
                }
              });
            }
    //       }
    //     });
    //   });
    // });
  }

  getUserDetailsById(id: number) {
    this.userService.getUserFromID(id).subscribe((res) => {
      if (res) {
        this.userDetails = res;
        this.authService.setUser(res);
        this.storageService.setItem(StorageKey.USER, JSON.stringify(res), StorageType.LOCAL);
        this.storageService.setItem(StorageKey.IS_LOGGED_IN, 'true', StorageType.LOCAL);
        this.cacheService.onUserDetailsChange(res);
      }
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  updateUserDetails() {
    const countrydata = this.countryCodes.find((x) => x.code == this.form.value.phoneNumber.split('-')[0]);
    this.country = countrydata.country;
    var mobileNumber: any = this.phoneNumber;
    if (
      !mobileNumber ||
      typeof mobileNumber === 'function' // Check if it's a function
    ) {
      mobileNumber = this.phoneNumber; // Set the default phone number value
    }
    this.registration = {
      id: this.userID,
      name: this.form.value.name,
      email: this.email,
      isActive: true,
      password: this.password,
      mobile: mobileNumber,
      createdDateTime: this.transformDate(new Date())?.toString(),
      //modifiedBy: '',
      userTypeId: 1,
      lastModified: this.transformDate(new Date())?.toString(),
      registrationUrl: String(window.location.pathname),
      sourceNameId: this.sourceId,
      ipCountry: this.country,
      ipAddress: this.clientIPAdress,
      // city: '',
      //VerificationId: this.verificationId,
      otp: this.otp,
      userDetails: {
        id: 0,
        grade: String(this.form.value.gradeId),
        userId: this.userID,
        //schoolName: '',
        modifiedDate: this.transformDate(new Date())?.toString(),
        country: this.country,
        city: this.city,
      },
      mobileVerification: {
        verificationId: 0,
      },
    };
    if (this.pageType != LeadFormType.Forum) {
      this.userService.updateUserDetail(this.userID, this.registration).subscribe((data) => {
        this.authenticateAndFinalize(
          this.email,
          this.password,
          this.userID,
          true,
          `You're successfully logged in!`
        );
      });
    } else {
      this.modalService.open(ConnectToCounsellorComponent, { centered: true, backdrop: 'static' });
    }
  }

  private persistAuthResponse(response: any): number | null {
    return this.authService.handleAuthResponse(response);
  }

  private authenticateAndFinalize(
    email: string,
    password: string,
    fallbackUserId: number,
    isExistingUser: boolean,
    successMessage: string
  ): void {
    const loginData = email && password ? { Email: email, Password: password } : null;
    const login$ = loginData ? this.userService.loginWithEmailId(loginData) : of(null);

    login$.subscribe({
      next: (loginResponse) => {
        const authenticatedUserId =
          this.persistAuthResponse(loginResponse) ??
          Number(loginResponse?.userId ?? loginResponse?.result?.value?.id ?? fallbackUserId ?? 0);

        this.userID = authenticatedUserId || fallbackUserId;
        this.getUserDetailsById(this.userID);
        this.isRegistered.emit(isExistingUser);
        this.isUserLogged.emit(true);
        this.userid.emit(this.userID);
        this.closeModal();
        this.isLoading = false;
        this.notificationService.notifyMessage(NotificationType.Success, successMessage);
        this.getUserStatus();
        this.cmsService.hideNRIBookNowButton();
      },
      error: () => {
        this.userID = fallbackUserId;
        this.getUserDetailsById(this.userID);
        this.isRegistered.emit(isExistingUser);
        this.isUserLogged.emit(true);
        this.userid.emit(this.userID);
        this.closeModal();
        this.isLoading = false;
        this.notificationService.notifyMessage(NotificationType.Success, successMessage);
        this.getUserStatus();
        this.cmsService.hideNRIBookNowButton();
      },
    });
  }

  getUserStatus(): any {
    if (this.UserId) {
      this.trialService.GetOrder(this.UserId).subscribe((data) => {
        if (data.length > 0) {
        } else {
          setTimeout(() => {
            const modalRef = this.modalService.open(TrialUserComponent, {
              centered: true,
              size: 'xl',
              backdrop: 'static',
            });
            modalRef.componentInstance.UserId = this.UserId;
            modalRef.componentInstance.GradeId = this.form.value.gradeId;
          }, 3000);
        }
      });
    }
  }
}
